import React from 'react';

interface GoldenLaurelProps {
  size?: number;
  className?: string;
}

/**
 * Golden Laurel wreath SVG icon — used for festival/award listings.
 * Transparent background, golden gradient fill.
 */
export default function GoldenLaurel({ size = 24, className = '' }: GoldenLaurelProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="laurelGold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F5C842" />
          <stop offset="50%" stopColor="#E8A800" />
          <stop offset="100%" stopColor="#C8860A" />
        </linearGradient>
      </defs>
      {/* Left branch */}
      <path
        d="M4.5 12c-.8-1.2-.9-2.8-.2-4 .5-.9 1.4-1.5 2.3-1.8-.1 1.1.2 2.2.8 3.1.4.6.9 1.1 1.5 1.4C8 11.9 7 13 6.2 14.3c-.7-1-1.3-1.5-1.7-2.3z"
        fill="url(#laurelGold)"
      />
      <path
        d="M3 14.5c-.5-1.4-.3-3 .5-4.2.5-.8 1.3-1.4 2.1-1.7 0 1.1.4 2.2 1.1 3 .4.5.9 1 1.5 1.3-.8 1.2-1.7 2.2-2.4 3.5-.8-1-1.5-1.8-1.8-2.9z"
        fill="url(#laurelGold)"
      />
      <path
        d="M2.5 17c-.2-1.5.3-3 1.2-4.1.5-.6 1.2-1.1 2-1.4.1 1.1.6 2.1 1.3 2.9.4.5.9.9 1.4 1.2-.6 1.3-1.3 2.5-1.8 3.8-.9-.9-1.7-1.7-2.2-2.8-.5-.5-.8-1-.9-1.6z"
        fill="url(#laurelGold)"
      />
      {/* Right branch */}
      <path
        d="M19.5 12c.8-1.2.9-2.8.2-4-.5-.9-1.4-1.5-2.3-1.8.1 1.1-.2 2.2-.8 3.1-.4.6-.9 1.1-1.5 1.4.9 1.2 1.9 2.3 2.7 3.6.7-1 1.3-1.5 1.7-2.3z"
        fill="url(#laurelGold)"
      />
      <path
        d="M21 14.5c.5-1.4.3-3-.5-4.2-.5-.8-1.3-1.4-2.1-1.7 0 1.1-.4 2.2-1.1 3-.4.5-.9 1-1.5 1.3.8 1.2 1.7 2.2 2.4 3.5.8-1 1.5-1.8 1.8-2.9z"
        fill="url(#laurelGold)"
      />
      <path
        d="M21.5 17c.2-1.5-.3-3-1.2-4.1-.5-.6-1.2-1.1-2-1.4-.1 1.1-.6 2.1-1.3 2.9-.4.5-.9.9-1.4 1.2.6 1.3 1.3 2.5 1.8 3.8.9-.9 1.7-1.7 2.2-2.8.5-.5.8-1 .9-1.6z"
        fill="url(#laurelGold)"
      />
      {/* Center ribbon / base */}
      <path
        d="M10.5 19.5c.4.3.9.5 1.5.5s1.1-.2 1.5-.5l.5-.5H10l.5.5z"
        fill="url(#laurelGold)"
      />
      <path
        d="M9.5 18.5h5c.3-.4.5-.9.5-1.5H9c0 .6.2 1.1.5 1.5z"
        fill="url(#laurelGold)"
      />
    </svg>
  );
}
